import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { OfferPriceData, ProductData } from "./commerce/cart.types";
import { getCartStore } from "./utils";
import { AmountDto } from "./api";
import Alpine from "alpinejs";

export class ProductContextComponent extends AlpineComponent {
    public showFloatingAddToCartButton: boolean = false;
    public productData: ProductData;
    public currentOfferPrice?: OfferPriceData | null;
    public calculatedTotalAmount: AmountDto | null | undefined = null;

    constructor(
        productData: ProductData,
        currentOfferPrice?: OfferPriceData,
    ) {
        super();
        this.productData = window.Alpine.reactive(productData);
        this.productData.quantity = 1;
        this.productData.optionalExtras.forEach(extra => {
            extra.quantity = extra.suggestedQuantity ?? 0;
            extra.selected = false;
        });

        this.currentOfferPrice = currentOfferPrice ?? this.determineCurrentOfferPrice();
    }

    protected AddToCartButton = this.binding({
        ["x-on:click.prevent"]() {
            this.addToCart();
        }
    });

    protected IncreaseQuantityButton = this.binding({
        ["x-on:click.prevent"]() {
            this.increaseQuantity();
        }
    });
    protected DecreaseQuantityButton = this.binding({
        ["x-on:click.prevent"]() {
            this.decreaseQuantity();
        }
    });

    init(): void {
        this.$watch("productData", () => {
            this.currentOfferPrice = this.determineCurrentOfferPrice();
        })
        Alpine.effect(() => {
            const currentOfferPrice = this.currentOfferPrice?.offerPrice;
            const productDataPrice = this.productData.price;
            const price = currentOfferPrice ?? productDataPrice;
            const unitPriceWithTax = price.withTax;
            const extrasTotalWithTax = this.productData.optionalExtras
                .filter(o => o.selected)
                .reduce((sum, extra) => {
                    const extraUnitPriceTax = extra.price.withTax;
                    return sum + (extraUnitPriceTax * extra.quantity);
                }, 0);

            const totalPriceWithTax = (unitPriceWithTax * this.productData.quantity) + extrasTotalWithTax;
            this.calculatedTotalAmount = {
                value : totalPriceWithTax,// `${symbol}${amountToDecimalUnits(totalPriceWithTax).toString()}`,
                formatted: {
                    value: totalPriceWithTax.toFixed(2),
                }
            };
        });
    }

    async addToCart(silent: boolean = false) {
        await getCartStore().AddProduct({
            productReference: this.productData.productReference,
            productVariantReference: this.productData.productVariantReference,
            quantity: this.productData.quantity,
            bundleItems: this.productData.bundlableProducts?.filter(b => b.quantity > 0)
                                                            .map(b => ({
                productReference: b.productReference,
                productVariantReference: b.productVariantReference,
                quantity: b.quantity
            })) ?? [],
            optionalExtras: this.productData.optionalExtras?.filter(o => o.selected && o.quantity > 0)
                                                            .map(o => ({
                productReference: o.productReference,
                productVariantReference: o.productVariantReference,
                quantity: o.quantity * this.productData.quantity
            })) ?? [],
        }, !silent);
    }
    async increaseQuantity() {
        this.productData.quantity += 1;
    }

    async decreaseQuantity() {
        this.productData.quantity = Math.max(1, this.productData.quantity - 1);
    }

    eligableForDiscountedPrice(): boolean {
        if(this.productData.hasPriceBreaks && this.productData.offerPrices) {
            for(const offer of this.productData.offerPrices) {
                if(this.productData.quantity >= offer.minimumQuantity) {
                    return true;
                }
            }
        } else if(this.productData.offerPrices && this.productData.offerPrices.length > 0) {
            return true;
        }
        return false;
    }
    determineCurrentOfferPrice(): OfferPriceData | undefined {
        this.currentOfferPrice = undefined;

        if(this.productData.hasPriceBreaks && this.productData.offerPrices) {
            for(const offer of this.productData.offerPrices) {
                if(this.productData.quantity >= offer.minimumQuantity) {
                    this.currentOfferPrice = offer;
                }
            }
        } else if(this.productData.offerPrices && this.productData.offerPrices.length > 0) {
            this.currentOfferPrice = this.productData.offerPrices[0];
        }
        return this.currentOfferPrice;
    }


    /* Bindings */
    protected floatingAddToCartButton = this.binding({
        ["x-show"]() {
             return this.showFloatingAddToCartButton;
        },
        ["x-transition:enter"](){return "transition ease-out duration-1250"},
        ["x-transition:enter-start"](){return "top-0"},
        ["x-transition:enter-end"](){return "top-(--site-header-height)"},
        ["x-transition:leave"](){return "transition ease-in duration-1250"},
        ["x-transition:leave-start"](){return "top-(--site-header-height)"},
        ["x-transition:leave-end"](){return "top-0"}
    });
}